<template>
  <div class="global-container">
    <div class="space-3"></div>
    <div class="projekte__head">
      <h1>Unsere Projekte</h1>
      <BaseBtn
        variant="primary"
        @click="filterOpen = !filterOpen"
        class="mobile-display"
      >
        Filter
      </BaseBtn>
      <div class="btns__flex">
        <div
          class="filter__btn__wrapper"
          :class="{ show__filters: showFilters }"
        >
          <filterBtn
            v-for="category in categories"
            :key="category"
            :category="category"
            :selectedCategory="selectedCategory"
            @update:filter="selectedCategory = $event"
          >
            {{ category }}
          </filterBtn>
        </div>
      </div>
    </div>
    <div class="projekte__grid">
      <ProjektCard
        v-for="projekt in filteredProjects"
        :key="projekt.id"
        :title="projekt.title"
        :URLtitle="projekt.URLtitle"
        :id="projekt.id"
        :imageSrc="projekt.imageSrc"
        :category="projekt.category"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { projects } from "@/data/data";
import BaseBtn from "@/components/BaseBtn.vue";
import ProjektCard from "@/components/ProjektCard.vue";
import filterBtn from "@/components/filterBtn.vue";

// Reactive state
const selectedCategory = ref("A–Z"); // Default is "A–Z"
const filterOpen = ref(false);
const categories = ref([
  "A–Z",
  "Gestaltungen",
  "Licht",
  "Projektionen",
  "Sonderkonstruktionen",
  "Wasser",
]);

const filteredProjects = computed(() => {
  if (selectedCategory.value === "A–Z") {
    return [...projects].sort((a, b) => a.title.localeCompare(b.title));
  }

  const filtered = projects.filter(
    (p) => p.category === selectedCategory.value
  );

  if (filtered.length === 0) {
    return projects;
  }

  return filtered;
});

const windowWidth = ref(window.innerWidth);

const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWindowWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowWidth);
});

const showFilters = computed(() => {
  return windowWidth.value >= 768 ? true : filterOpen.value;
});
</script>

<style scoped lang="scss">
.projekte__grid {
  display: grid;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    column-gap: map-get($spaces, "xl");
  }
  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 2000px) {
    grid-template-columns: repeat(4, 1fr);
  }
  width: 100%;
}

.filter__btn__wrapper .filterBtn {
  cursor: pointer;
}

.filter__btn__wrapper {
  display: none;
  &.show__filters {
    display: block;
  }
}
.projekte__head {
  display: flex;
  flex-direction: column;
  .btns__flex {
    margin: map-get($spaces, "xl") 0;

    @media (max-width: 768px) {
      margin: map-get($spaces, "md") 0;
    }
  }
}
.mobile-display {
  margin-top: map-get($spaces, "md");
  @media (min-width: 768px) {
    display: none;
  }
}
</style>
